let language = {
    CRAFT_SHOP_DOWNLOAD_TEMPLATE_ERROR_TITLE: 'download error',
    CRAFT_SHOP_DOWNLOAD_TEMPLATE_ERROR_CONTENT: 'An error occurred downloading the template',
    CRAFT_SHOP_DOWNLOAD_TEMPLATE_ERROR_5500003: 'The template file does not exist',
    CRAFT_SHOP_UPLOAD_ORDER_ERROR_TITLE: 'Invalid File Format: ',
    CRAFT_SHOP_UPLOAD_ORDER_ERROR_CONTENT: 'The uploaded file is not in the correct format. Please update it and try again.',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_CONTENT: 'An error occurred importing the order',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_5500001: 'The uploaded file is not in the correct format. Please update it and try again.',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_5500002: 'The uploaded file is not in the correct format. Please update it and try again.',
    CRAFT_SHOP_UPLOAD_ORDER_ERRORS_5700001: 'File archive failure',
    CRAFT_SHOP_DELETE_ORDER_ITEM_HINT_TITLE: 'Delete Confirmation',
    CRAFT_SHOP_DELETE_ORDER_ITEM_HINT_CONTENT: 'Are you sure you want to delete current order item?',
    CRAFT_SHOP_DELETE_ORDER_ITEM_ERRORS_TITLE: 'deletion error',
    CRAFT_SHOP_DELETE_ORDER_ITEM_ERRORS_CONTENT: 'An error occurred deleting the order',
    CRAFT_SHOP_DELETE_ORDER_ITEM_ERRORS_5500004: 'The import is successful and cannot be deleted',

    CRAFT_SHOP_DELETE_ORDER_HINT_TITLE: 'Delete Confirmation',
    CRAFT_SHOP_DELETE_ORDER_HINT_CONTENT: 'Are you sure you want to delete all items related to this order?',
    CRAFT_SHOP_DELETE_ORDER_ERRORS_TITLE: 'deletion error',
    CRAFT_SHOP_DELETE_ORDER_ERRORS_CONTENT: 'An error occurred deleting the order',
    CRAFT_SHOP_DELETE_ORDER_ERRORS_5500005: 'The order has been successfully imported and cannot be deleted.',
    CRAFT_SHOP_DELETE_ALL_ORDER_ITEM_HINT_TITLE: 'Delete Confirmation',
    CRAFT_SHOP_DELETE_ALL_ORDER_ITEM_HINT_CONTENT: 'This action will permanently delete all order data, including imported items. Are you sure you want to proceed?',





    CRAFT_SHOP_DOWNLOAD_TEMPLATE_BTN: 'DOWNLOAD TEMPLATE',
    CRAFT_SHOP_UPLOAD_ORDER_FILE_BTN: 'UPLOAD ORDER FILE',
    CRAFT_SHOP_IMPORT_HISTORY_BTN: 'IMPORT HISTORY',
    CRAFT_SHOP_IMPORT_ERRORS_BTN: 'IMPORT ERRORS',
    CRAFT_SHOP_IMPORT_FILE_DETAILS_BTN: 'Import File Details',
    CRAFT_SHOP_BACK_TO_CUSTOMER_ORDERS_BTN: 'BACK TO CUSTOMER ORDERS',
    CRAFT_SHOP_BACK_TO_IMPORT_HISTORY_BTN: 'BACK TO IMPORT HISTORY',
    CRAFT_SHOP_RETRY_ALL_FAILED_IMPORTS_BTN: 'RETRY ALL FAILED IMPORTS',
    CRAFT_SHOP_DELETE_ALL_FAILED_IMPORTS_BTN: 'DELETE ALL FAILED IMPORTS',
    CRAFT_SHOP_CREATE_NEW_ORDER_BTN: 'CREATE NEW ORDER',
    CRAFT_SHOP_REFRESH_BTN: 'REFRESH',






    CRAFT_SHOP_ORDER_INFO_LIST_IMPORT_FILE: 'Import File',
    CRAFT_SHOP_ORDER_INFO_LIST_IMPORT_DATE: ' Import Date',
    CRAFT_SHOP_ORDER_INFO_LIST_STATUS: 'Status',
    CRAFT_SHOP_ORDER_INFO_LIST_OPERATION: 'Operation',
    CRAFT_SHOP_ORDER_INFO_LIST_TOTAL: 'Total:',
    CRAFT_SHOP_ORDER_INFO_LIST_IMPORT_COMPLETE: 'Import Complete:',
    CRAFT_SHOP_ORDER_INFO_LIST_FAILED: 'Failed:',
    CRAFT_SHOP_ORDER_INFO_LIST_AWAITING_IMPORT: 'Awaiting Import:',

};

export { language }